var _jsxFileName = "/home/runner/work/frontend/frontend/libs/ui-design-system/src/components/Molecules/CheckboxGroup/CheckboxItem.tsx",
  _this = this;
import { Box, Typography } from '@mui/material';
import { Icon, FormControlLabel } from "../../..";
import { StyledCheckbox, StyledCheckboxLabel, StyledCheckedIconWrapper, StyledUncheckedIcon } from "./CheckboxGroup.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CheckboxItem = function CheckboxItem(_ref) {
  var value = _ref.value,
    label = _ref.label,
    checkboxInformation = _ref.checkboxInformation,
    checked = _ref.checked,
    onChange = _ref.onChange,
    name = _ref.name;
  return _jsxs(Box, {
    children: [_jsx(FormControlLabel, {
      control: _jsx(StyledCheckbox, {
        name: name,
        checked: checked,
        onChange: onChange,
        value: value,
        disableRipple: true,
        icon: _jsx(StyledUncheckedIcon, {}),
        checkedIcon: _jsx(StyledCheckedIconWrapper, {
          children: _jsx(Icon, {
            name: "checkmark",
            sx: {
              color: '#ffffff'
            },
            w: 8
          })
        })
      }),
      label: _jsx(StyledCheckboxLabel, {
        children: label
      }),
      sx: {
        alignItems: 'flex-start'
      }
    }), _jsx(Typography, {
      variant: "body1",
      component: "p",
      children: checkboxInformation
    })]
  });
};
//# sourceMappingURL=CheckboxItem.js.map